/* eslint-disable no-new */

import msgpad_show from "../msgpad_show"
import {base_api} from '@/api/base_api';


const st_shop_key = "shop_info";

const state = {
  shop_info: null
}

// getters
const getters = {
	shop_info         : state => {
		if(state.shop_info) return state.shop_info;
		let shop_info = localStorage.getItem(st_shop_key);
		if(shop_info) {
			try{
				state.shop_info = JSON.parse(shop_info);
			}catch(err){
				debugger
				msgpad_show("msgpad", "失败", err.message, 'error')
			}
		}
		return state.shop_info
	},
}


// actions
const actions = {
	act_look_shop_info(context, data) {
		return base_api({
			method:'post',
			schema:'shopinfo',
			params:{action:'shop_login'},
			data
        }).then(resp=>{
        	context.commit('MUTATIONS_SHOP_SHOP_INFO',resp.data);
        	return resp.data;
        })
	},
	act_sysuser_login(context, data) {
		return base_api({
			method:'post',
			schema:'shopinfo',
			params:{action:'shop_login'},
			data
        }).then(resp=>{
        	context.commit('MUTATIONS_SHOP_SHOP_INFO',resp.data);
        	return resp.data;
        })
	}
}

// mutations
const mutations = {
  	MUTATIONS_SHOP_SHOP_INFO(state, info) {
		if(info){
			state.shop_info = info;
			localStorage.setItem(st_shop_key,JSON.stringify(info));
		}else{
			state.shop_info = info;
			localStorage.removeItem(st_shop_key);
		}
  	}
}




export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/shop_store.js